<template>
	<div class="wrapper" @click="show=false">
		<b-container>
			<little-bar class="mt-5" :current="current" :navlist="navlist" :year="year" fontColor="#666666"
				@changeCurrent="changeCurrent">
				<template v-slot:right-nav>
					<div>
						<div class="year-btn" @click.stop="showDropDown">
							<div ><span v-if="$store.state.screenWidth > 769" style="padding-right: 2rem">{{$t('lang.years')}}：</span>{{ yearActive }}</div>
							<b-icon class="arrow" icon="chevron-down"></b-icon>
						</div>
						<div v-show="show" class="drop-down" @mouseleave="show = false">
							<div class="drop-item" v-for="(item, index) in year.sub" :key="index"
								@click="searchYear(item.text)">
								{{ item.text }}
							</div>
						</div>
					</div>
				</template>
			</little-bar>
			<news-list :newList="newsList"></news-list>
			<b-pagination v-if="totalRow / perPage > 1" class="pt-5 pb-5" align="center" :hide-goto-end-buttons="true" :hide-ellipsis="true"
				v-model="currentPage" :total-rows="totalRow" :per-page="perPage" @input="chagePage"></b-pagination>
		</b-container>
	</div>
</template>
<script>
	import newsList from '@/components/newsList.vue'
	export default {
		components: {
			newsList
		},
		data() {
			return {
				totalRow: 0,
				currentPage: 1, //当前页
				perPage: 0, //每页十条
				current: 0,
				show: false,
				navlist: [{
						text: this.$t('lang.LatestNews'),
						// text: '最新资讯',
						link: '/news/list?tab=0&type=0',
					},
					{
						text: this.$t('lang.Notice'),
						// text: '公告',
						link: '/news/list?tab=1&type=1',
					},
					// {
					// 	text: this.$t('lang.PressConference'),
					// 	// text: '新闻发布会',
					// 	link: '/news/list?type=2',
					// },
					// {
					// 	text: this.$t('lang.IwithL'),
					// 	// text: '获奖人专访',
					// 	link: '/news/list?type=3',
					// },
					// {
					// 	text: this.$t('lang.NandI'),
					// 	// text: '更多',
					// 	link: '/news/list?type=4',
					// },
				],
				year: {
					text: '年份',
					link: '',
					sub: [{
						text: 'ALL'
					}, ],
				},
				yearActive: 'ALL',
				newsList: []
			}
		},
		watch: {
			$route: {
				handler(val) {
					//新路由
				//	this.current = val.query.tab
					this.init(val.query.tab, val.query.type)
					this.yearActive = 'ALL'
					// this.lisitenPath(val)
				},
				immediate: true
			},
			yearActive: {
				handler(val) {
					if (val == 'ALL') {
						this.init(this.$route.query.tab, this.$route.query.type)
					} else {
						this.init(this.$route.query.tab, this.$route.query.type, val)
					}
				},
				deep: true,
			}

		},
		created() {
			this.current = this.$route.query.tab
			this.getYear()
			this.getTabData()
		},
		methods: {
			//列表栏数据
			getTabData() {
				this.$api.newsCategory()
					.then(res => {
						let arr = res.data.map((item, index) => {
							return {
								text: item.name,
								link: `/news/list?tab=${index+2}&type=${item.id}`
							}
						})
						this.navlist.push(...arr)
					})
			},
			searchYear(year) {
				this.yearActive = year
				// this.init(this.$route.query.tab, this.$route.query.type, year)
			},
			//获取下拉年份
			getYear() {
				this.$api.newsYear()
					.then(res => {
						let arr = res.data.map(item => {
							return {
								text: item
							}
						})
						this.year.sub.push(...arr)
					})
			},
			init(tab, type, year, page = 1) { //分类， 年份， 页码
				switch (tab) {
					case '0':
						this.getNewsList(page, 10, year);
						break;
					case '1':
						this.getNoticeList(page, 10, year);
						break;
					default:
						this.getNewsCategory(page, 10, type, year);
						break;
				}
			},
			chagePage(index) {
				this.init(this.$route.query.tab, this.$route.query.type, this.yearActive == 'ALL'? '': this.yearActive, index)
				window,scrollTo(0,0)
			},
			showDropDown() {
				this.show = !this.show;
			},
			changeCurrent(index, path) {
				this.$router.push(path);
				this.current = index;
				this.currentPage = 1
			},
			getNoticeList(page, limit, year) {
				this.perPage = limit
				this.$api.noticeList({
						page: page,
						limit: limit,
						year: year
					})
					.then(res => {
						this.newsList = res.data.records;
						this.totalRow = res.data.total;
					})
			},
			getNewsList(page, limit, year) {
				this.perPage = limit
				this.$api.newsList({
						page: page,
						limit: limit,
						year: year
					})
					.then(res => {
						this.newsList = res.data.records;
						this.totalRow = res.data.total;
					})
			},
			getNewsCategory(page, limit, id, year) {
				this.$api.newsSearch({
						page: page,
						limit: limit,
						categoryId: id,
						year: year
					})
					.then(res => {
						this.newsList = res.data.records;
						this.totalRow = res.data.total;
					})
			}
		},
	}
</script>
<style lang="scss" scoped>
	.wrapper::v-deep {
		.page-link {
			font-size: 1.2rem;
			color: #4a4a4a;
		}

		.page-item.active .page-link {
			z-index: 3;
			color: #fff;
			background-color: #cfaf75;
			border-color: #cfaf75;
		}

		.page-link:focus {
			box-shadow: none;
			color: #fff !important;
		}
	}

	.page-link:focus {
		box-shadow: none
	}

	.year-btn {
		display: flex;
		padding: 0 0.5rem;
		align-items: center;
		cursor: pointer;
	}

	.drop-down {
		position: relative;
		text-align: center;
		background-color: #fff;
		z-index: 999;
		cursor: pointer;
		width: 70%;
		left: 30%;
		line-height: 2.7rem;

		.drop-item:hover {
			color: #c8a063;
		}
	}
</style>